import birthdate from 'is-valid-birthdate';
import phone from 'phone';
import isUrl from 'is-url';

export function isValidBirthdate(date) {
  const [month, day, year] = date.split('/');
  return {
    valid: birthdate([year, month, day].join('-')),
    message: 'Please enter a valid date.',
  };
}

export function isValidCVC(cvc) {
  var strongRegex = new RegExp(/\d{3}/);
  return strongRegex.test(cvc);
}

export function isValidMonth(month) {
  var strongRegex = new RegExp(/\d{2}/);
  return strongRegex.test(month);
}

export function isValidYear(year) {
  var strongRegex = new RegExp(/\d{2}/);
  return strongRegex.test(year);
}

export function isValidPassword(password) {
  var strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})'
  );
  return strongRegex.test(password);
}

export function isValidPhoneNumber(number) {
  const valid = phone(number).length;
  return {
    valid,
    message: !valid && 'Please enter a valid phone number',
  };
}

export function isValidUrl(str) {
  str = 'https://' + str.replace('https://', '');
  return {
    valid: isUrl(str),
    message: 'Please enter a valid url',
  };
}

export function checkForUndefinedState(fieldsArray, state) {
  return fieldsArray.find(field => {
    if (field && typeof state[field] === 'undefined') {
      return true;
    }
  });
}

export function checkForStaleState(pageDefinedChecksArray, page, state, resetResult = true) {
  let pageToGoTo = false;
  const pages = pageDefinedChecksArray.length;

  Array(pages + 1)
    .fill(0)
    .forEach((_, index) => {
      if (index === 0) {
        return;
      }

      let pageIsNotValid = !!checkForUndefinedState(
        pageDefinedChecksArray[index - 1],
        state
      );

      if (pageIsNotValid && !pageToGoTo) {
        pageToGoTo = index;
      }

      if (resetResult && (page > pageToGoTo)) {
        /** this means that it needs to be reset to the beginning page */
        pageToGoTo = true;
      }
    });
  return pageToGoTo;
}
